import React from 'react';
import { useModal } from '@hooks';
import HowToFindPropertyId from '../components/HowToFindPropertyId';

export const usePropertyIdModal = () => {
    const { open, close } = useModal();

    const showPropertyIdModal = () => {
        open({
            title: <span data-e2e='tracking_ga-property-id-modal_title'>How to Find Your GA4 Property ID</span>,
            content: <HowToFindPropertyId close={close} />,
            settings: { maskClosable: false }
        });
    };

    return { showPropertyIdModal, close };
};
